import React from 'react';
import { Head } from '../head/Head';

export const Main = () => {
	return (
		<>
			<Head />
		</>
	);
};
